import {defineStore} from 'pinia'
import moment from "moment";

export const DashboardRangeStore = defineStore('dashboardRangeStore', {
    state: () => ({
        rangeOptions: [
            {id: 'today', label: 'Сегодня', from: moment().format("YYYY-M-D"), to: moment().format("YYYY-M-D")},
            // {id: 'yesterday', label: 'Вчера', from: moment().subtract(1, 'days').format("YYYY-M-D"), to: moment().subtract(1, 'days').format("YYYY-M-D")},
            {id: 'last_7', label: 'Последние 7 дней', from: moment().subtract(7, 'days').format("YYYY-M-D"), to: moment().format("YYYY-M-D")},
            {id: 'last_30', label: 'Последние 30 дней', from: moment().subtract(30, 'days').format("YYYY-M-D"), to: moment().format("YYYY-M-D")},
            {id: 'last_90', label: 'Последние 90 дней', from: moment().subtract(90, 'days').format("YYYY-M-D"), to: moment().format("YYYY-M-D")},
        ],
        currentRange: {id: 'last_7', label: 'Последние 7 дней', from: moment().subtract(6, 'days').format("YYYY-M-D"), to: moment().format("YYYY-M-D")},
    }),
    getters: {
        getCurrentRangeFrom() {},
        getCurrentRangeTo() {},
    },
    actions: {
        updateCurrentRange(val: any) {
            this.currentRange = val
        }
    }
})
